export default function TenjinContact() {
  return (
    <section id="contact" className="py-24 bg-gray-900">
      <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <span className="text-xs tracking-[0.3em] text-amber-400/70 font-medium uppercase mb-4 block">Contact</span>
        <h2 className="text-4xl md:text-5xl font-serif text-white mb-4">無料査定のご依頼</h2>
        <div className="w-16 h-0.5 bg-amber-400/30 mx-auto mb-6"></div>
        <p className="text-white/60 text-sm max-w-lg mx-auto leading-relaxed mb-12">
          福岡市・福岡県全域への出張買取は完全無料。<br />
          LINEまたはお電話でお気軽にご連絡ください。
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
          <a
            href="https://lin.ee/OGQq9z6"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#06C755] rounded-2xl p-7 flex flex-col items-center gap-4 hover:bg-[#05b34c] transition-colors cursor-pointer group"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-full group-hover:bg-white/30 transition-colors">
              <i className="ri-line-fill text-white text-2xl"></i>
            </div>
            <div>
              <p className="text-white font-semibold text-base mb-1">LINEで相談</p>
              <p className="text-white/70 text-xs">天神屋 公式LINE</p>
            </div>
            <span className="text-xs text-white/60 bg-white/10 px-3 py-1 rounded-full">おすすめ・最速対応</span>
          </a>

          <a
            href="tel:092-577-9739"
            className="bg-white/10 rounded-2xl p-7 flex flex-col items-center gap-4 hover:bg-white/15 transition-colors cursor-pointer group"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-white/10 rounded-full group-hover:bg-white/20 transition-colors">
              <i className="ri-phone-line text-white text-2xl"></i>
            </div>
            <div>
              <p className="text-white font-semibold text-base mb-1">電話で相談</p>
              <p className="text-amber-300 text-lg font-semibold tracking-wide">092-577-9739</p>
            </div>
            <span className="text-xs text-white/60 bg-white/10 px-3 py-1 rounded-full">平日・土日祝 10:00〜19:00</span>
          </a>

          <a
            href="mailto:info@botan-buy.com"
            className="bg-white/10 rounded-2xl p-7 flex flex-col items-center gap-4 hover:bg-white/15 transition-colors cursor-pointer group"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-white/10 rounded-full group-hover:bg-white/20 transition-colors">
              <i className="ri-mail-line text-white text-2xl"></i>
            </div>
            <div>
              <p className="text-white font-semibold text-base mb-1">メールで相談</p>
              <p className="text-white/70 text-xs">info@botan-buy.com</p>
            </div>
            <span className="text-xs text-white/60 bg-white/10 px-3 py-1 rounded-full">24時間受付</span>
          </a>
        </div>

        <div className="bg-white/5 rounded-xl px-6 py-4 inline-flex items-center gap-3">
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className="ri-map-pin-line text-amber-400 text-sm"></i>
          </div>
          <p className="text-white/50 text-xs">
            〒810-0075 福岡県福岡市中央区港1-2-18-1712 ／ 古物商許可 福岡県公安委員会 901012610013
          </p>
        </div>
      </div>
    </section>
  );
}
